import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import Banner from "../components/Banner";
import SliderContainer from "../components/SliderContainer";
import { Footer } from "../Footer";

import { base_url } from "../../context/Authcontext";
import { useNavigate } from "react-router-dom";


const CQ9Home = () => {
  const [isSidebar, setSidebar] = useState(false);
  const navigate= useNavigate();
 

  const cQ9_games=[
    {
      name: "Thai HILO",
      GAMEID: "e1bf4c2cf1dcf91182d3caf8e944f425",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Thai-HILO.png"
    },
    {
      name: "Xoc Dia",
      GAMEID: "87593975049b4839c5b9883188c825b8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Xoc-Dia.png"
    },
    {
      name: "Mr.Bean",
      GAMEID: "83bc9b50ddeb49403086070bc61c8dac",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mr.Bean.png"
    },
    {
      name: "Thai Fish Prawn Crab",
      GAMEID: "1636a3694f9eaab1ee27c253c43591aa",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Thai-Fish-Prawn-Crab.png"
    },
    {
      name: "Tenfold Eggs",
      GAMEID: "4bcc8e305d6747e524d698ce02c9e2c7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Tenfold-Eggs.png"
    },
    {
      name: "Funky Bingo",
      GAMEID: "2075dc1439923a3210deba122fc0d631",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Funky-Bingo.png"
    },
    {
      name: "Jungle Party",
      GAMEID: "bac6b204228688e24eb808caaa459f78",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Jungle-Party.png"
    },
    {
      name: "Mummy's Treasure",
      GAMEID: "0fec5546ea03487eed57e76d4e57e608",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mummys-Treasure.png"
    },
    {
      name: "Mini Roulette",
      GAMEID: "421ca8d057205d7af4e8cfea22cc906b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mini-Roulette-.png"
    },
    {
      name: "Mahjong Fruit",
      GAMEID: "52db8e8d4992293d9061398fc3f3869d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mahjong-Fruit.png"
    },
    {
      name: "K.O. Island",
      GAMEID: "55170f3e8904083bb698e15494175b85",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/K.O.-Island.png"
    },
    {
      name: "Dragon Ball Dozer",
      GAMEID: "5a0a7ee701c44fe34549b44333666148",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Ball-Dozer.png"
    },
    {
      name: "3 2 1Go!",
      GAMEID: "c002f8b5cd124abe27b50d5e082364f4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/3-2-1Go!.png"
    },
    {
      name: "Hanuman Bingo",
      GAMEID: "df98d0dcddb7526eecc11fe760a7d531",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hanuman-Bingo.png"
    },
    {
      name: "Alice Run",
      GAMEID: "7c0f4e40cbbfee4d8017b42cb081ed1e",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Alice-Run.png"
    },
    {
      name: "Dragon Pachinko",
      GAMEID: "3f475158ba1e056a4858b18ba72a2887",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Pachinko.png"
    },
    {
      name: "Seotda",
      GAMEID: "8b410b635a270f49ff933fd188741abf",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Seotda.png"
    },
    {
      name: "Alice Run JP",
      GAMEID: "b4c1e40c11261a77bdfa76dad2585da4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Alice-Run-JP.png"
    },
    {
      name: "Oneshot Fishing",
      GAMEID: "8beb52f0188e78a2f39cd5ea63e22232",
     provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Oneshot-Fishing.png"
    },
    {
      name: "Paradise",
      GAMEID: "201cd3554cef14c33b4f4011a9506d8d",
     provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Paradise.png"
    },
    {
      name: "Hero Fishing",
      GAMEID: "97bf63574981264cb987c086f51c4664",
     provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hero-Fishing.png"
    },
    {
      name: "LuckyFishing",
      GAMEID: "bdbb2665530867b57a3e3a42103fe39a",
     provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LuckyFishing.png"
    },
    {
      name: "Yaxing Live",
      GAMEID: "a751336c5ece3bedbed5b5d73113b665",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Yaxing-Live.png"
    },
    {
      name: "motivation gaming",
      GAMEID: "709f3ade034d0eb105e087a0f8bebc09",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/motivation-gaming.png"
    },
    {
      name: "CQ9 Lottery",
      GAMEID: "349cbd98815ed9b8cb3d081956760bbc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/CQ9-Lottery.png"
    },
    {
      name: "JumpHigh",
      GAMEID: "630a841b4cf75a38e2e657040f785e63",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/JumpHigh.png"
    },
    {
      name: "Rave Jump",
      GAMEID: "b602205d6a56d999df188e17ecc2bc91",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Rave-Jump.png"
    },
    {
      name: "Jump High 2",
      GAMEID: "8d57ec6274960fe2f2c252f4a49adf7f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Jump-High-2.png"
    },
    {
      name: "Jumping mobile",
      GAMEID: "1282953e9452fe2852cb1724b4b9d617",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Jumping-mobile.png"
    },
    {
      name: "Good Fortune M",
      GAMEID: "50568ba2a8da9f30dded83dbbd3655d6",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Good-Fortune-M.png"
    },
    {
      name: "God of War",
      GAMEID: "f4b6484dc2b96fc339604446cd042534",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/God-of-War.png"
    },
    {
      name: "FlyOut",
      GAMEID: "afddbebb27c4b7408bda624aa9354aa7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/FlyOut.png"
    },
    {
      name: "Zeus",
      GAMEID: "0f944952a27be9ab52d8deabf275a552",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Zeus.png"
    },
    {
      name: "DiscoNight M",
      GAMEID: "82839530d48814c586b8844b84693ca4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/DiscoNight-M.png"
    },
    {
      name: "Lucky Bats",
      GAMEID: "c069592afd5d6ffab7bf759a491a71cd",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lucky-Bats.png"
    },
    {
      name: "Good Fortune",
      GAMEID: "61d7c57fedb24242f4e56df7d5c80bfd",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Good-Fortune.png"
    },
    {
      name: "JumpHigher",
      GAMEID: "80af0735d78f6056a920770abca9f51c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/JumpHigher.png"
    },
    {
      name: "Fa Cai Shen2",
      GAMEID: "da2929eef2ac66b7b3d44fdf0655c27a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fa-Cai-Shen2.png"
    },
    {
      name: "God of War M",
      GAMEID: "46c55e2ba632f9ae9addda6e169f7743",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/God-of-War-M.png"
    },
    {
      name: "Money Tree",
      GAMEID: "cee72070e3d6fee077cfcb9a050df57d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Money-Tree.png"
    },
    {
      name: "Rave Jump mobile",
      GAMEID: "7b0b749b726371330c991ad01513539a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Rave-Jump-mobile.png"
    },
    {
      name: "Lucky Bats M",
      GAMEID: "8d505ecfefce9b2c3058f58b415782b2",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lucky-Bats-M.png"
    },
    {
      name: "5 God Beasts",
      GAMEID: "7148d1ecd2f6787e3d4cfae4580a7b86",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/5-God-Beasts.png"
    },
    {
      name: "THOR",
      GAMEID: "8e77c76cd001acc431fb96ce6d216f80",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/THOR.png"
    },
    {
      name: "Cricket Fever",
      GAMEID: "a36b6a69ffa118773a5e828bcc74dcf8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Cricket-Fever.png"
    },
    {
      name: "FaCaiShen",
      GAMEID: "4fc25c66cbfd8068ff4a12faffe62469",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/FaCaiShen.png"
    },
    {
      name: "Gu Gu Gu 3",
      GAMEID: "260d42bbe34ce7149c636e339100364b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Gu-Gu-Gu-3.png"
    },
    {
      name: "Move n' Jump",
      GAMEID: "8eba0f6d7c38fa6ced38f3abc6409e7f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Move-n-Jump.png"
    },
    {
      name: "Jump Higher mobile",
      GAMEID: "e78b31bc60d05582a34cc19871520cb6",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Jump-Higher-mobile.png"
    },
    {
      name: "Flying Cai Shen",
      GAMEID: "660de502d52d1f4566aeab989491686f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Flying-Cai-Shen.png"
    },
    {
      name: "Fire Chibi 2",
      GAMEID: "b05efbb809025d5450f08bdec8febee2",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire-Chibi-2.png"
    },
    {
      name: "DiscoNight",
      GAMEID: "4b5dce5597380d02a6daa1946ebfd118",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/DiscoNight.png"
    },
    {
      name: "Wonderland",
      GAMEID: "8764cec7c0232e476536c00145089732",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wonderland.png"
    },
    {
      name: "Thor 2",
      GAMEID: "585f5e69e9fd929d2a78e3d392a22c8e",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Thor-2.png"
    },
    {
      name: "Da Hong Zhong",
      GAMEID: "09000b2086ef8632326e33b75714639b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Da-Hong-Zhong.png"
    },
    {
      name: "Zhong Kui",
      GAMEID: "f57af26972d04aeb3918b407fd280187",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Zhong-Kui.png"
    },
    {
      name: "Da Fa Cai",
      GAMEID: "7781583727b17e3c0abd06033338f15b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Da-Fa-Cai.png"
    },
    {
      name: "Flower Fortunes",
      GAMEID: "db0174a59d12ec0480cdfafa50fe8103",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Flower-Fortunes.png"
    },
    {
      name: "Fire Queen 2",
      GAMEID: "a1f1dac8df2ab915628830539f8bb7d7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire-Queen-2-.png"
    },
    {
      name: "Baseball Fever",
      GAMEID: "1b2895c147b842611771c9815000aaa4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Baseball-Fever.png"
    },
    {
      name: "Double Fly",
      GAMEID: "dabd7e6cc8c05effa4d868ebc088f189",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Double-Fly-.png"
    },
    {
      name: "Night City",
      GAMEID: "20ac774b757e927af3fd59a67e39254a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Night-City.png"
    },
    {
      name: "Funny Alpaca",
      GAMEID: "a6eeb19d6fce96c0b2aef905f01cd46b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Funny-Alpaca.png"
    },
    {
      name: "Invincible Elephant",
      GAMEID: "c66bcf7a826e781c96cd214c97ae2b67",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Invincible-Elephant.png"
    },
    {
      name: "Chameleon",
      GAMEID: "88e704fd702c1318b8ac1b2c540ea308",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Chameleon.png"
    },
    {
      name: "Treasure Pirate",
      GAMEID: "870473a09d666f7c52c3e655f2b64b77",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Treasure-Pirate.png"
    },
    {
      name: "Six Candy",
      GAMEID: "aaff1c8eea4138515f7dc48b9c28503b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Six-Candy.png"
    },
    {
      name: "Fa Cai Shen M",
      GAMEID: "4c5fff40be0ac1e597fa24f3c0a656e9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fa-Cai-Shen-M.png"
    },
    {
      name: "TreasureBowl",
      GAMEID: "5172f73c2829b9cec48b0c7d856ae26a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TreasureBowl.png"
    },
    {
      name: "888 Cai Shen",
      GAMEID: "28a39e51864bae9fcebdbc6f738815de",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/888-Cai-Shen.png"
    },
    {
      name: "Hercules",
      GAMEID: "93060689fb6ddb3823702549ae22fbc7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hercules.png"
    },
    {
      name: "Fire Queen",
      GAMEID: "43177e1be3e726f8dd532c594a0fe54f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire-Queen.png"
    },
    {
      name: "So Sweet",
      GAMEID: "6e5050176c0efae891a5bcc9e8958329",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/So-Sweet.png"
    },
    {
      name: "GuGuGu",
      GAMEID: "7ecdf8a456674beeb3665f2a0e15e322",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/GuGuGu.png"
    },
    {
      name: "RaveHigh",
      GAMEID: "191678951989eed5609ce6cf2252f0c1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/RaveHigh.png"
    },
    {
      name: "Pyramid Raider",
      GAMEID: "068f8d42261ce77fef124de9608dc391",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Pyramid-Raider.png"
    },
    {
      name: "Snow Queen",
      GAMEID: "7da3427f512c0ba7fe9acb69daab425d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Snow-Queen.png"
    },
    {
      name: "Water Margin",
      GAMEID: "fc003ead2149c77c1bb174cbfbdbe7bb",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Water-Margin.png"
    },
    {
      name: "Hot Spin",
      GAMEID: "7057b9185aaee613216ff18352ad1c2f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hot-Spin.png"
    },
    {
      name: "Super5",
      GAMEID: "e8a984c3aa5e951ef92b053b32ea7dd1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Super5.png"
    },
    {
      name: "Wolf Disco",
      GAMEID: "ec50f4c2e123475287a6bac7239d6db8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wolf-Disco.png"
    },
    {
      name: "Football Fever M",
      GAMEID: "63adb18577103f9631aec0712cb398e2",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Football-Fever-M.png"
    },
    {
      name: "Fire Chibi",
      GAMEID: "da8208a22454260a50438c1e1806ea69",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire-Chibi.png"
    },
    {
      name: "6 Toros",
      GAMEID: "4b4d1cb0e676f342db428ac898d5a3ac",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/6-Toros.png"
    },
    {
      name: "Mirror Mirror",
      GAMEID: "d9550ed556610505851f425c37fb57fd",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mirror-Mirror.png"
    },
    {
      name: "MuayThai",
      GAMEID: "a27e8f382f0ce434b0c42079ebe33221",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MuayThai.png"
    },
    {
      name: "Rave Jump2",
      GAMEID: "b9aeb15cd98fb93d5dca0bbddbc9c79f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Rave-Jump2.png"
    },
    {
      name: "Aladdin's lamp",
      GAMEID: "44b775adacc090fd07ad6b24a6b55963",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Aladdins-lamp.png"
    },
    {
      name: "Striker WILD",
      GAMEID: "4a3a333562badf48383a10c7fbf8de26",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Striker-WILD.png"
    },
    {
      name: "WaterWorld",
      GAMEID: "0eebf2f9aaa4705795ce5b01780751ef",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WaterWorld.png"
    },
    {
      name: "Fa Cai Fu Wa",
      GAMEID: "bad08f4186e60ce20918fcc23a955d7c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fa-Cai-Fu-Wa.png"
    },
    {
      name: "Mr. Miser",
      GAMEID: "264af007099b8306f9c4e4e45485500d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mr.-Miser.png"
    },
    {
      name: "Uproar In Heaven",
      GAMEID: "86c2ea7d87d4ca8f8f305a0a0b0de846",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Uproar-In-Heaven.png"
    },
    {
      name: "GuGuGu2",
      GAMEID: "506e63d96c5377a1d0d2368357e323f9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/GuGuGu2.png"
    },
    {
      name: "Wheel Money",
      GAMEID: "cf4cfcd1f517360be7e3f5e35cb277ef",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wheel-Money.png"
    },
    {
      name: "5 Boxing",
      GAMEID: "6075420770ec2fe9c31b48159729299c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/5-Boxing.png"
    },
    {
      name: "Dragon Ball",
      GAMEID: "83e1f2077918e63f9cbde70f6e3d9ce0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Ball.png"
    },
    {
      name: "The Beast War",
      GAMEID: "8c9750a6cc03f3d0af0a7853ac124fda",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Beast-War.png"
    },
    {
      name: "HappyRichYear",
      GAMEID: "cbce4da7f8b89f8b6b569af14af75d9c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/HappyRichYear.png"
    },
    {
      name: "Floating Market",
      GAMEID: "a34f4808447d12be37d16adf9eaed572",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Floating-Market.png"
    },
    {
      name: "King of Atlantis",
      GAMEID: "e4a15094c2ae54ffc6d77187fff0d2d7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/King-of-Atlantis.png"
    },
    {
      name: "Apsaras",
      GAMEID: "feb4444198c8146d213f9594325ff7d7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Apsaras.png"
    },
    {
      name: "The Chicken House",
      GAMEID: "2e5f381d3f9db2217fb113c829a79f2a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Chicken-House.png"
    },
    {
      name: "Zeus M",
      GAMEID: "fb33a6613e5ba5b8e42f035fbd4e103d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Zeus-M.png"
    },
    {
      name: 777,
      GAMEID: "521c3e444d06b25dc5ed6b6768200d44",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/777.png"
    },
    {
      name: "LuckyBatsJP",
      GAMEID: "9bef1fbf45383b40e170c57a06352a37",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LuckyBatsJP.png"
    },
    {
      name: "WuKong&Peaches",
      GAMEID: "d0436aec31880e65ad98eef9b3981fcb",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WuKong&Peaches.png"
    },
    {
      name: "Sky Lanterns",
      GAMEID: "48f9ce3f231f3993c6ec908509d61688",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sky-Lanterns.png"
    },
    {
      name: "Kronos",
      GAMEID: "f6747563ecef5cb4803e523cc40d7496",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Kronos.png"
    },
    {
      name: "Hephaestus",
      GAMEID: "ccd2f2ff80e15cf4972f1d6357c0f8d5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hephaestus.png"
    },
    {
      name: "King Kong Shake",
      GAMEID: "364284517a08f983992e3ee471960c0d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/King-Kong-Shake.png"
    },
    {
      name: "Gu Gu Gu 2 M",
      GAMEID: "24e0e334a06f1c2f609908ea51f56945",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/-Gu-Gu-Gu-2-M.png"
    },
    {
      name: "Fortune Dragon",
      GAMEID: "3b00fa061de9d0a6ed9843fa95ddb5dc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Dragon.png"
    },
    {
      name: "Shou-Xin",
      GAMEID: "2b0b1d8d7c8c49ae282f328795916fd1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Shou-Xin.png"
    },
    {
      name: "Mafia",
      GAMEID: "a239266b6011750a0105b676ca92b2f3",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mafia.png"
    },
    {
      name: "Hot DJ",
      GAMEID: "3f1df3f204333b25730681b291a60333",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hot-DJ.png"
    },
    {
      name: "Mr. Rich",
      GAMEID: "a34dc998bf7f4c4c0a62b2810cd0e30e",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mr.-Rich.png"
    },
    {
      name: "Rave Jump 2 M",
      GAMEID: "73e303cf417c6bd211ef536507a35b82",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Rave-Jump-2-M.png"
    },
    {
      name: "Fire Chibi M",
      GAMEID: "7fa49af4cf85457b5340d98cbe282563",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire-Chibi-M.png"
    },
    {
      name: "Wolf Moon",
      GAMEID: "fda7ba3b397e7940596a30639e2ab9e1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wolf-Moon.png"
    },
    {
      name: "Football Fever",
      GAMEID: "551c0c158cfcbe2d8c97960f70c7fec8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Football-Fever.png"
    },
    {
      name: "Golden Eggs",
      GAMEID: "69092d998124631d4a8925944bce67b5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Golden-Eggs.png"
    },
    {
      name: "CHICAGOⅡ",
      GAMEID: "1112003dee0f8525b1cbee98a6ab1368",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/CHICAGOII.png"
    },
    {
      name: "TreasureBowlJP",
      GAMEID: "a302435d829c9a6b823b508c2df7aec9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TreasureBowlJP.png"
    },
    {
      name: "Apollo",
      GAMEID: "9f6d5cad4677d3aa3feeb7b907d9a93a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Apollo.png"
    },
    {
      name: "OrientalBeauty",
      GAMEID: "0e15fd4fa6b9590001cdd71555bd8b87",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/OrientalBeauty.png"
    },
    {
      name: "Hero of the 3 Kingdoms - Cao Cao",
      GAMEID: "a174a38fb0fb007d348c03086ed0efed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hero-of-the-3-Kingdoms-Cao-Cao.png"
    },
    {
      name: "Sweet POP",
      GAMEID: "e51f1ecea20f87eee1149dac9e78852c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sweet-POP.png"
    },
    {
      name: "Myeong-ryang",
      GAMEID: "5c10bbe32ed9527d19711986973968a4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Myeong-ryang.png"
    },
    {
      name: "Treasure House",
      GAMEID: "8a244973588309c9d06b3d2f23020e1e",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Treasure-House.png"
    },
    {
      name: "Wing Chun",
      GAMEID: "c20937482acb4256f02c2d9f72258fbe",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wing-Chun.png"
    },
    {
      name: "Fortune Totem",
      GAMEID: "7941e7cf88f7a30533b7c7ab98b3c639",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Totem.png"
    },
    {
      name: "Running Animals",
      GAMEID: "522977276f1e38334bb71762710d1d8b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Running-Animals.png"
    },
    {
      name: "Fire777",
      GAMEID: "2453bbce4a11850700f3f8634a130e4f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire777.png"
    },
    {
      name: "Vampire Kiss",
      GAMEID: "b0bf4de1e3881b266a4dfc442e1f665d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Vampire-Kiss.png"
    },
    {
      name: "WanBaoDino",
      GAMEID: "557550df7526b2a8641c08b14c50304d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WanBaoDino.png"
    },
    {
      name: "Ne Zha Advent",
      GAMEID: "c0adf8478aef16eae670cce8258623b1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ne-Zha-Advent.png"
    },
    {
      name: "Greek Gods",
      GAMEID: "15e8bdff25079b4be98f84cdea37d1ed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Greek-Gods.png"
    },
    {
      name: "Zuma Wild",
      GAMEID: "b1c4e04fc5de9e6fe06baf44a650d0e6",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Zuma-Wild.png"
    },
    {
      name: "Dragon Koi",
      GAMEID: "f800040e6818ede103dc94b3d3bebbc5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Koi.png"
    },
    {
      name: "SkrSkr",
      GAMEID: "316d8570b1c69f52046d5bb0bbb0a0e3",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/SkrSkr.png"
    },
    {
      name: "Acrobatics",
      GAMEID: "b8f1a2b30586584ac0f20b9ba426ee60",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Acrobatics.png"
    },
    {
      name: "Ganesha Jr.",
      GAMEID: "461e0b9219d51eda0f6413b19153a1c6",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ganesha-Jr..png"
    },
    {
      name: "Yuan Bao",
      GAMEID: "5e4818e6c8946a3d71653e3d22a9a1c9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Yuan-Bao.png"
    },
    {
      name: "Wild Tarzan",
      GAMEID: "dd2046e37aa94f0a6b77497452ac0286",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wild-Tarzan.png"
    },
    {
      name: "Diamond treasure",
      GAMEID: "2f3e4881d605653d536e8b5ab21e113b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/-Diamond-treasure.png"
    },
    {
      name: "TreasureIsland",
      GAMEID: "b3c866fb2c529acf4175603e2c02d074",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TreasureIsland.png"
    },
    {
      name: "Red Phoenix",
      GAMEID: "a7034f531232014969b8b613fccd0a47",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Red-Phoenix.png"
    },
    {
      name: "Gu Gu Gu M",
      GAMEID: "b5d1c587f497cd331d18f3a618f99229",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Gu-Gu-Gu-M.png"
    },
    {
      name: "Detective Dee2",
      GAMEID: "d91e2b4c05cd7ac6ac59adb3d5f853ab",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Detective-Dee2.png"
    },
    {
      name: "Lucky Tigers",
      GAMEID: "b18de9efd3c251a32eed6ac7e97c67d7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lucky-Tigers.png"
    },
    {
      name: "Dragon Heart",
      GAMEID: "d8cb3a9429cd45c2ec612cb3220acecd",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Heart.png"
    },
    {
      name: "Lord Ganesha",
      GAMEID: "89c763b3761557eaa960d022cdd73921",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lord-Ganesha.png"
    },
    {
      name: "Hot Pinatas",
      GAMEID: "171dd44d68bd47df9d2bc386082ca340",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hot-Pinatas.png"
    },
    {
      name: 888,
      GAMEID: "708c6a3de19dd4d7674efea3ef2fe40f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/888.png"
    },
    {
      name: "RunningToro",
      GAMEID: "2df7d3f0fb6dc289a29d58067ab1c596",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/RunningToro.png"
    },
    {
      name: "Gold Stealer",
      GAMEID: "9cec85e2f5c2a0545c10825e897ec433",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Gold-Stealer.png"
    },
    {
      name: "All Star Team",
      GAMEID: "8677aafb4968ee948c42ef31cbcc6c66",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/All-Star-Team.png"
    },
    {
      name: "Dragon's Treasure",
      GAMEID: "9b8589482492af6a92397a889ce24784",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragons-Treasure.png"
    },
    {
      name: "Great Lion",
      GAMEID: "e91f6b84921858afd5a62284d0dfa89b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Great-Lion.png"
    },
    {
      name: "Burning Xi-You",
      GAMEID: "979fc001722dd7c46edab5a787b86d21",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Burning-Xi-You.png"
    },
    {
      name: "All Wilds",
      GAMEID: "bb5c0ea65687c2ee63980f644045f9e4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/All-Wilds.png"
    },
    {
      name: "Jewel Luxury",
      GAMEID: "572ed9f08de5745603c052fd759989c5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Jewel-Luxury.png"
    },
    {
      name: "Meow",
      GAMEID: "271a0b04341b9b57c9fd46dbc8bb333a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Meow.png"
    },
    {
      name: "Loy Krathong",
      GAMEID: "d63414a615aa145466625ec440176f8e",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Loy-Krathong.png"
    },
    {
      name: "The Cupids",
      GAMEID: "3c71b0060fe7214f73ac21af86148b03",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Cupids.png"
    },
    {
      name: "Fruit King",
      GAMEID: "748c8f874063d6629dfc910dd38e85e5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fruit-King.png"
    },
    {
      name: "Chicky Parm Parm",
      GAMEID: "ff89d148948baec771661f4047e7215c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Chicky-Parm-Parm.png"
    },
    {
      name: "WonWonWon",
      GAMEID: "5c60a8521f10c864de5b1da61e1b014c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WonWonWon.png"
    },
    {
      name: "Magic World",
      GAMEID: "4c70c186616f00adb7cec5d6e58ed604",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Magic-World.png"
    },
    {
      name: "Sherlock Holmes",
      GAMEID: "f4ee292edc93a670a25e31e3d8ae3303",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sherlock-Holmes.png"
    },
    {
      name: "Summer Mood",
      GAMEID: "d67b92dd4bc3a7180aecf6a5f4eb61ed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Summer-Mood.png"
    },
    {
      name: "God Of Chess",
      GAMEID: "f72b5f2d241bc0ee370965f21692b96d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/God-Of-Chess.png"
    },
    {
      name: "FruitKingII",
      GAMEID: "737224273b2595a5fc6d5b419611ff00",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/FruitKingII.png"
    },
    {
      name: "Xmas",
      GAMEID: "86731029d440380de665d1705be2cbc8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Xmas.png"
    },
    {
      name: "Six Gacha",
      GAMEID: "a1676b8d40667bab6d107601347ab3c6",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Six-Gacha.png"
    },
    {
      name: "Gophers War",
      GAMEID: "82af8f5ea9cb9003accab2a685f6b7dc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Gophers-War.png"
    },
    {
      name: "Ninja Raccoon",
      GAMEID: "071b756a4d6b454a87641fa021d18e11",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ninja-Raccoon.png"
    },
    {
      name: "Fruity Carnival",
      GAMEID: "d859be0e915d1b72d6c3125fd3764eb0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fruity-Carnival.png"
    },
    {
      name: "Football Baby",
      GAMEID: "9f0cc6b78e12cc19bcfcd95488b5d781",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Football-Baby.png"
    },
    {
      name: "Pharaoh's Gold",
      GAMEID: "d40765682df6cd384a6624bdf2a6be8f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Pharaohs-Gold.png"
    },
    {
      name: "Poseidon",
      GAMEID: "2d44ee24e038513e1d8680d4dd534348",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Poseidon.png"
    },
    {
      name: "LongLongLong",
      GAMEID: "cf576c4aecc1bd3b077b4a78d1b426ec",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LongLongLong.png"
    },
    {
      name: "Detective Dee",
      GAMEID: "bda2e6a2e08382ae3e6cc407ab2a209c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Detective-Dee.png"
    },
    {
      name: "LuckyBoxes",
      GAMEID: "bcefd23a1c86c94c430ca39868eb36cc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LuckyBoxes.png"
    },
    {
      name: "Crazy NuoZha",
      GAMEID: "b9a08190e3f3aec328ddae2b0c43bb15",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Crazy-NuoZha.png"
    },
    {
      name: "Ecstatic Circus",
      GAMEID: "7f8fd8227e3b31934e1d86c0a5afb938",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ecstatic-Circus.png"
    },
    {
      name: "Dollar Bomb",
      GAMEID: "b54ad2b8e8217c07a22495f18589c276",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dollar-Bomb.png"
    },
    {
      name: "Fortune Gate",
      GAMEID: "a493bdd1bbe559f7a3fa5e5947982242",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Gate.png"
    },
    {
      name: "Sakura Legend",
      GAMEID: "8658e005b8bffc8e727a8846dae13900",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sakura-Legend.png"
    },
    {
      name: "Songkran Festival",
      GAMEID: "2cb558412aaccd52d6ad8b436953c73c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Songkran-Festival.png"
    },
    {
      name: "Coin Spinner",
      GAMEID: "48d0db2eab9a513a3c0974896e2ba704",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Coin-Spinner.png"
    },
    {
      name: "XIYOUJI",
      GAMEID: "4023d4dc30fb1e751576018ff64610df",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/XIYOUJI.png"
    },
    {
      name: "Sun Er Niang",
      GAMEID: "807a7b2beca7903201adb021098ad95c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sun-Er-Niang.png"
    },
    {
      name: "The Dragon Brings Wealth",
      GAMEID: "57e95e50da6625ed1e3c00e6266e39cb",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Dragon-Brings-Wealth.png"
    },
    {
      name: "ROLLING DRAGON",
      GAMEID: "77c171c91fb589c2c91879a4ebe8c911",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/ROLLING-DRAGON-.png"
    },
    {
      name: "Lonely Planet",
      GAMEID: "b8d4831b3631a06e1bfbe3da5e951789",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lonely-Planet.png"
    },
    {
      name: "World Cup Russia2018",
      GAMEID: "2409e5731f75846c32589aa11e97bf7b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/World-Cup-Russia2018.png"
    },
    {
      name: "Football Boots",
      GAMEID: "2058fb035a2950763935dcdb3552046d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Football-Boots.png"
    },
    {
      name: "Oo Ga Cha Ka",
      GAMEID: "109f1875d5ab0981b08e958828a6118d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Oo-Ga-Cha-Ka.png"
    },
    {
      name: "MONKEY KING",
      GAMEID: "fed3b52ed8e9d709e637a9482f576c64",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MONKEY-KING.png"
    },
    {
      name: "Monster Hunter",
      GAMEID: "01d19cf2fedc3bc18e2b8e880af687ed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Monster-Hunter.png"
    },
    {
      name: "JIN LIAN PAN",
      GAMEID: "2745d0933a8ab0621b76bb93f5a549cc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/JIN-LIAN-PAN-.png"
    },
    {
      name: "GoldenEggsJP",
      GAMEID: "6da38883f15c06b796d8daaed7f80939",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/GoldenEggsJP.png"
    },
    {
      name: "LongLaiFa",
      GAMEID: "ca69f05fd2a52a9fdee69dd819cbb4be",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LongLaiFa.png"
    },
    {
      name: "HUGA",
      GAMEID: "4e46334e0abde53e5e6cabe78f106764",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/HUGA.png"
    },
    {
      name: "PARTY ISLAND",
      GAMEID: "9b7af082e879ebb276affc760668b54d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/PARTY-ISLAND.png"
    },
    {
      name: "Double Happiness",
      GAMEID: "3632e72eedf24ef82f034d02282f90d4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Double-Happiness.png"
    },
    {
      name: "Big Wolf",
      GAMEID: "4fc02a42d9981442dc20fe9e03d169ad",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Big-Wolf.png"
    },
    {
      name: "Empress Wu",
      GAMEID: "0582ab3045c14b6268606c11f4d19f95",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Empress-Wu-.png"
    },
    {
      name: "TIGER HERO",
      GAMEID: "f523bb4fbe0dad42c44121cfdfe3ec9d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TIGER-HERO.png"
    },
    {
      name: "MonkeyOfficeLegend",
      GAMEID: "a26b4a919b9bc8865599ca5f105a8e58",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MonkeyOfficeLegend.png"
    },
    {
      name: "Pub Tycoon",
      GAMEID: "3a2bd5e7a1b3366cde75570d3ad93de8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Pub-Tycoon.png"
    },
    {
      name: "MULAN",
      GAMEID: "bb28e417cbd03f0ab9be560fdf7773e9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MULAN.png"
    },
    {
      name: "Mega Winner",
      GAMEID: "6667585b48442cde4516e2f6648dc530",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mega-Winner.png"
    },
    {
      name: "Lin Chong",
      GAMEID: "d46355c4d9fc77c4ae9d9df297390fb0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lin-Chong.png"
    },
    {
      name: "Slot 777",
      GAMEID: "3d76faac5931819507b7dfba02377f35",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Slot-777.png"
    },
    {
      name: "Lucky 3",
      GAMEID: "a369313204e62dbc8584d75cd3addc82",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lucky-3.png"
    },
    {
      name: "Pig Of Luck",
      GAMEID: "ef392c2fec8ad75d77131252b6ff3663",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Pig-Of-Luck.png"
    },
    {
      name: "Boots of Luck",
      GAMEID: "316b9e21b4bde165e506351ecf833930",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Boots-of-Luck.png"
    },
    {
      name: "Fortune Spirits",
      GAMEID: "a7f80a70e62368c389a23b300ccbf8a1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Spirits.png"
    },
    {
      name: "GENIE",
      GAMEID: "598c5d9c30378fdd48d4dfa2bb8c0c46",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/GENIE.png"
    },
    {
      name: "Rush Hour",
      GAMEID: "9d9bf67a8b6b1faf5a1dbfe6ff3dd206",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Rush-Hour.png"
    },
    {
      name: "Treasure of Seti",
      GAMEID: "528101a83d7f3518896e4fce061948f7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Treasure-of-Seti.png"
    },
    {
      name: "Wild Fudge",
      GAMEID: "cb9ddf2d9f433e19ca3d7fda21e520c9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wild-Fudge.png"
    },
    {
      name: "Diamond Fruit",
      GAMEID: "1360fd1d5b971769cdbc922b51303e3a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Diamond-Fruit.png"
    },
    {
      name: "Da Fu Xing",
      GAMEID: "804e9adae94f35f16a2d93bc584f7da0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Da-Fu-Xing.png"
    },
    {
      name: "Master Panda",
      GAMEID: "4a687f358c03e98ffbc4df618b2f1566",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Master-Panda.png"
    },
    {
      name: "Queen Of Dead",
      GAMEID: "f09e471f10d60dfc7fd9876c6711d8c8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Queen-Of-Dead.png"
    },
    {
      name: "Songkran",
      GAMEID: "fb1c07944e9b30c773975d5761f715b3",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Songkran.png"
    },
    {
      name: "Dragon Hunters",
      GAMEID: "9a1d746be3ce06c9617fde95da7299e7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Hunters.png"
    },
    {
      name: "The Legend Of Snake",
      GAMEID: "6ac22b2754657ac1f92c52c216ca3123",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Legend-Of-Snake-.png"
    },
    {
      name: "Niu Niu Niu",
      GAMEID: "ca92c58e1ba7a064226fd292e08f1e1f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Niu-Niu-Niu.png"
    },
    {
      name: "Royal Fruit",
      GAMEID: "2dc730c7c7cabe3ced14eadf4f800d23",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Royal-Fruit.png"
    },
    {
      name: "Golden Mayan",
      GAMEID: "4ca28ba2df8175e7742aafb08cb93acb",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Golden-Mayan.png"
    },
    {
      name: "Wild Chameleon",
      GAMEID: "1449bcd0cf997fcbd5db51b71f5a3afd",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wild-Chameleon.png"
    },
    {
      name: "Hollywood Pets",
      GAMEID: "b3626929bd5b55514e43cc9ea30ecdcf",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hollywood-Pets.png"
    },
    {
      name: "Fishing King",
      GAMEID: "396c1296f9805ec93cb73764c11e939b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fishing-King.png"
    },
    {
      name: "Myth",
      GAMEID: "6d7d54e9ac5d6fbccb4e90f59bb07f54",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Myth.png"
    },
    {
      name: "Nezha",
      GAMEID: "c7177ae93f8b8ad8015d1c15fc84358f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Nezha.png"
    },
    {
      name: "HAPPY BUDDHA",
      GAMEID: "7e64a66d0d74af9f173ab913576b61ce",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/HAPPY-BUDDHA.png"
    },
    {
      name: "Cirque de fous",
      GAMEID: "d9d86e86284357426995e080250e2662",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Cirque-de-fous.png"
    },
    {
      name: "JUNGLE ISLAND",
      GAMEID: "8797a9b3500b2cc510aab54f8f65c9b0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/JUNGLE-ISLAND.png"
    },
    {
      name: "Hong Kong Flavor",
      GAMEID: "32b8e2de14d2dc9fa7de9e60c39181e2",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hong-Kong-Flavor.png"
    },
    {
      name: "Beanstalk",
      GAMEID: "bc6315b1d328ba2a6719d3ce54ecfc6d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Beanstalk.png"
    },
    {
      name: "Xmas Tales",
      GAMEID: "5aa01f1fb8c92635c69d399deda516b2",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Xmas-Tales.png"
    },
    {
      name: "Peeking Banker Bull-Bull",
      GAMEID: "e21186914febf15786f84951e013a37a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Peeking-Banker-Bull-Bull.png"
    },
    {
      name: "Banker Dice Bull-Bull",
      GAMEID: "874ef5c8f7c51b3e6e8d8f3189917219",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Banker-Dice-Bull-Bull.png"
    },
    {
      name: "Thai Pok Deng",
      GAMEID: "5843c49f399e462d8e4852c45bf14d34",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Thai-Pok-Deng.png"
    }
  ]
  const hot_games=[
   
    {
      name: "Mummy's Treasure",
      GAMEID: "0fec5546ea03487eed57e76d4e57e608",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mummys-Treasure.png"
    },
    {
      name: "Mini Roulette",
      GAMEID: "421ca8d057205d7af4e8cfea22cc906b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mini-Roulette-.png"
    },
    {
      name: "Mahjong Fruit",
      GAMEID: "52db8e8d4992293d9061398fc3f3869d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mahjong-Fruit.png"
    },
   
    {
      name: "God of War M",
      GAMEID: "46c55e2ba632f9ae9addda6e169f7743",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/God-of-War-M.png"
    },
    {
      name: "Money Tree",
      GAMEID: "cee72070e3d6fee077cfcb9a050df57d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Money-Tree.png"
    },
    
    {
      name: "Fa Cai Shen M",
      GAMEID: "4c5fff40be0ac1e597fa24f3c0a656e9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fa-Cai-Shen-M.png"
    },
    {
      name: "TreasureBowl",
      GAMEID: "5172f73c2829b9cec48b0c7d856ae26a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TreasureBowl.png"
    },
    {
      name: "888 Cai Shen",
      GAMEID: "28a39e51864bae9fcebdbc6f738815de",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/888-Cai-Shen.png"
    },
    {
      name: "Hercules",
      GAMEID: "93060689fb6ddb3823702549ae22fbc7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hercules.png"
    },
    {
      name: "Fire Queen",
      GAMEID: "43177e1be3e726f8dd532c594a0fe54f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire-Queen.png"
    },
    {
      name: "So Sweet",
      GAMEID: "6e5050176c0efae891a5bcc9e8958329",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/So-Sweet.png"
    },
    {
      name: "GuGuGu",
      GAMEID: "7ecdf8a456674beeb3665f2a0e15e322",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/GuGuGu.png"
    },
    {
      name: "RaveHigh",
      GAMEID: "191678951989eed5609ce6cf2252f0c1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/RaveHigh.png"
    },
    {
      name: "Pyramid Raider",
      GAMEID: "068f8d42261ce77fef124de9608dc391",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Pyramid-Raider.png"
    },
    {
      name: "Snow Queen",
      GAMEID: "7da3427f512c0ba7fe9acb69daab425d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Snow-Queen.png"
    },
    {
      name: "Water Margin",
      GAMEID: "fc003ead2149c77c1bb174cbfbdbe7bb",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Water-Margin.png"
    },
    {
      name: "Hot Spin",
      GAMEID: "7057b9185aaee613216ff18352ad1c2f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hot-Spin.png"
    },
    {
      name: "Super5",
      GAMEID: "e8a984c3aa5e951ef92b053b32ea7dd1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Super5.png"
    },
    {
      name: "Wolf Disco",
      GAMEID: "ec50f4c2e123475287a6bac7239d6db8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wolf-Disco.png"
    },
    {
      name: "Football Fever M",
      GAMEID: "63adb18577103f9631aec0712cb398e2",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Football-Fever-M.png"
    },
    {
      name: "Fire Chibi",
      GAMEID: "da8208a22454260a50438c1e1806ea69",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire-Chibi.png"
    },
    {
      name: "6 Toros",
      GAMEID: "4b4d1cb0e676f342db428ac898d5a3ac",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/6-Toros.png"
    },
    {
      name: "Mirror Mirror",
      GAMEID: "d9550ed556610505851f425c37fb57fd",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mirror-Mirror.png"
    },
    {
      name: "MuayThai",
      GAMEID: "a27e8f382f0ce434b0c42079ebe33221",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MuayThai.png"
    },
    {
      name: "Rave Jump2",
      GAMEID: "b9aeb15cd98fb93d5dca0bbddbc9c79f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Rave-Jump2.png"
    },
    {
      name: "Aladdin's lamp",
      GAMEID: "44b775adacc090fd07ad6b24a6b55963",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Aladdins-lamp.png"
    },
    {
      name: "Striker WILD",
      GAMEID: "4a3a333562badf48383a10c7fbf8de26",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Striker-WILD.png"
    },
    {
      name: "WaterWorld",
      GAMEID: "0eebf2f9aaa4705795ce5b01780751ef",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WaterWorld.png"
    },
    {
      name: "Fa Cai Fu Wa",
      GAMEID: "bad08f4186e60ce20918fcc23a955d7c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fa-Cai-Fu-Wa.png"
    },
    {
      name: "Mr. Miser",
      GAMEID: "264af007099b8306f9c4e4e45485500d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mr.-Miser.png"
    },
    {
      name: "Uproar In Heaven",
      GAMEID: "86c2ea7d87d4ca8f8f305a0a0b0de846",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Uproar-In-Heaven.png"
    },
    {
      name: "GuGuGu2",
      GAMEID: "506e63d96c5377a1d0d2368357e323f9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/GuGuGu2.png"
    },
    {
      name: "Wheel Money",
      GAMEID: "cf4cfcd1f517360be7e3f5e35cb277ef",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wheel-Money.png"
    },
    {
      name: "5 Boxing",
      GAMEID: "6075420770ec2fe9c31b48159729299c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/5-Boxing.png"
    },
    {
      name: "Dragon Ball",
      GAMEID: "83e1f2077918e63f9cbde70f6e3d9ce0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Ball.png"
    },
    {
      name: "The Beast War",
      GAMEID: "8c9750a6cc03f3d0af0a7853ac124fda",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Beast-War.png"
    },
    {
      name: "HappyRichYear",
      GAMEID: "cbce4da7f8b89f8b6b569af14af75d9c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/HappyRichYear.png"
    },
    {
      name: "Floating Market",
      GAMEID: "a34f4808447d12be37d16adf9eaed572",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Floating-Market.png"
    },
    {
      name: "King of Atlantis",
      GAMEID: "e4a15094c2ae54ffc6d77187fff0d2d7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/King-of-Atlantis.png"
    },
    {
      name: "Apsaras",
      GAMEID: "feb4444198c8146d213f9594325ff7d7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Apsaras.png"
    },
    {
      name: "The Chicken House",
      GAMEID: "2e5f381d3f9db2217fb113c829a79f2a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Chicken-House.png"
    },
    {
      name: "Zeus M",
      GAMEID: "fb33a6613e5ba5b8e42f035fbd4e103d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Zeus-M.png"
    },
    {
      name: 777,
      GAMEID: "521c3e444d06b25dc5ed6b6768200d44",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/777.png"
    },
    {
      name: "LuckyBatsJP",
      GAMEID: "9bef1fbf45383b40e170c57a06352a37",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LuckyBatsJP.png"
    },
    {
      name: "WuKong&Peaches",
      GAMEID: "d0436aec31880e65ad98eef9b3981fcb",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WuKong&Peaches.png"
    },
    {
      name: "Sky Lanterns",
      GAMEID: "48f9ce3f231f3993c6ec908509d61688",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sky-Lanterns.png"
    },
    {
      name: "Kronos",
      GAMEID: "f6747563ecef5cb4803e523cc40d7496",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Kronos.png"
    },
    {
      name: "Hephaestus",
      GAMEID: "ccd2f2ff80e15cf4972f1d6357c0f8d5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hephaestus.png"
    },
    {
      name: "King Kong Shake",
      GAMEID: "364284517a08f983992e3ee471960c0d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/King-Kong-Shake.png"
    },
    {
      name: "Gu Gu Gu 2 M",
      GAMEID: "24e0e334a06f1c2f609908ea51f56945",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/-Gu-Gu-Gu-2-M.png"
    },
    {
      name: "Fortune Dragon",
      GAMEID: "3b00fa061de9d0a6ed9843fa95ddb5dc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Dragon.png"
    },
    {
      name: "Shou-Xin",
      GAMEID: "2b0b1d8d7c8c49ae282f328795916fd1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Shou-Xin.png"
    },
    {
      name: "Mafia",
      GAMEID: "a239266b6011750a0105b676ca92b2f3",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mafia.png"
    },
    {
      name: "Hot DJ",
      GAMEID: "3f1df3f204333b25730681b291a60333",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hot-DJ.png"
    },
    {
      name: "Mr. Rich",
      GAMEID: "a34dc998bf7f4c4c0a62b2810cd0e30e",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mr.-Rich.png"
    },
    {
      name: "Rave Jump 2 M",
      GAMEID: "73e303cf417c6bd211ef536507a35b82",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Rave-Jump-2-M.png"
    },
    {
      name: "Fire Chibi M",
      GAMEID: "7fa49af4cf85457b5340d98cbe282563",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire-Chibi-M.png"
    },
    {
      name: "Wolf Moon",
      GAMEID: "fda7ba3b397e7940596a30639e2ab9e1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wolf-Moon.png"
    },
    {
      name: "Football Fever",
      GAMEID: "551c0c158cfcbe2d8c97960f70c7fec8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Football-Fever.png"
    },
    {
      name: "Golden Eggs",
      GAMEID: "69092d998124631d4a8925944bce67b5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Golden-Eggs.png"
    },
    {
      name: "CHICAGOⅡ",
      GAMEID: "1112003dee0f8525b1cbee98a6ab1368",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/CHICAGOII.png"
    },
    {
      name: "TreasureBowlJP",
      GAMEID: "a302435d829c9a6b823b508c2df7aec9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TreasureBowlJP.png"
    },
    {
      name: "Apollo",
      GAMEID: "9f6d5cad4677d3aa3feeb7b907d9a93a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Apollo.png"
    },
    {
      name: "OrientalBeauty",
      GAMEID: "0e15fd4fa6b9590001cdd71555bd8b87",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/OrientalBeauty.png"
    },
    {
      name: "Hero of the 3 Kingdoms - Cao Cao",
      GAMEID: "a174a38fb0fb007d348c03086ed0efed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hero-of-the-3-Kingdoms-Cao-Cao.png"
    },
    {
      name: "Sweet POP",
      GAMEID: "e51f1ecea20f87eee1149dac9e78852c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sweet-POP.png"
    },
    {
      name: "Myeong-ryang",
      GAMEID: "5c10bbe32ed9527d19711986973968a4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Myeong-ryang.png"
    },
    {
      name: "Treasure House",
      GAMEID: "8a244973588309c9d06b3d2f23020e1e",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Treasure-House.png"
    },
    {
      name: "Wing Chun",
      GAMEID: "c20937482acb4256f02c2d9f72258fbe",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wing-Chun.png"
    },
    {
      name: "Fortune Totem",
      GAMEID: "7941e7cf88f7a30533b7c7ab98b3c639",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Totem.png"
    },
    {
      name: "Running Animals",
      GAMEID: "522977276f1e38334bb71762710d1d8b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Running-Animals.png"
    },
    {
      name: "Fire777",
      GAMEID: "2453bbce4a11850700f3f8634a130e4f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire777.png"
    },
    {
      name: "Vampire Kiss",
      GAMEID: "b0bf4de1e3881b266a4dfc442e1f665d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Vampire-Kiss.png"
    },
    {
      name: "WanBaoDino",
      GAMEID: "557550df7526b2a8641c08b14c50304d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WanBaoDino.png"
    },
    {
      name: "Ne Zha Advent",
      GAMEID: "c0adf8478aef16eae670cce8258623b1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ne-Zha-Advent.png"
    },
    {
      name: "Greek Gods",
      GAMEID: "15e8bdff25079b4be98f84cdea37d1ed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Greek-Gods.png"
    },
    {
      name: "Zuma Wild",
      GAMEID: "b1c4e04fc5de9e6fe06baf44a650d0e6",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Zuma-Wild.png"
    },
    {
      name: "Dragon Koi",
      GAMEID: "f800040e6818ede103dc94b3d3bebbc5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Koi.png"
    },
    {
      name: "SkrSkr",
      GAMEID: "316d8570b1c69f52046d5bb0bbb0a0e3",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/SkrSkr.png"
    },
    {
      name: "Acrobatics",
      GAMEID: "b8f1a2b30586584ac0f20b9ba426ee60",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Acrobatics.png"
    },
    {
      name: "Ganesha Jr.",
      GAMEID: "461e0b9219d51eda0f6413b19153a1c6",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ganesha-Jr..png"
    },
    {
      name: "Yuan Bao",
      GAMEID: "5e4818e6c8946a3d71653e3d22a9a1c9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Yuan-Bao.png"
    },
    {
      name: "Wild Tarzan",
      GAMEID: "dd2046e37aa94f0a6b77497452ac0286",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wild-Tarzan.png"
    },
    {
      name: "Diamond treasure",
      GAMEID: "2f3e4881d605653d536e8b5ab21e113b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/-Diamond-treasure.png"
    },
    {
      name: "TreasureIsland",
      GAMEID: "b3c866fb2c529acf4175603e2c02d074",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TreasureIsland.png"
    },
    {
      name: "Red Phoenix",
      GAMEID: "a7034f531232014969b8b613fccd0a47",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Red-Phoenix.png"
    },
    {
      name: "Gu Gu Gu M",
      GAMEID: "b5d1c587f497cd331d18f3a618f99229",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Gu-Gu-Gu-M.png"
    },
    {
      name: "Detective Dee2",
      GAMEID: "d91e2b4c05cd7ac6ac59adb3d5f853ab",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Detective-Dee2.png"
    },
    {
      name: "Lucky Tigers",
      GAMEID: "b18de9efd3c251a32eed6ac7e97c67d7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lucky-Tigers.png"
    },
    {
      name: "Dragon Heart",
      GAMEID: "d8cb3a9429cd45c2ec612cb3220acecd",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Heart.png"
    },
    {
      name: "Lord Ganesha",
      GAMEID: "89c763b3761557eaa960d022cdd73921",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lord-Ganesha.png"
    },
    {
      name: "Hot Pinatas",
      GAMEID: "171dd44d68bd47df9d2bc386082ca340",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hot-Pinatas.png"
    },
    {
      name: 888,
      GAMEID: "708c6a3de19dd4d7674efea3ef2fe40f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/888.png"
    },
    {
      name: "RunningToro",
      GAMEID: "2df7d3f0fb6dc289a29d58067ab1c596",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/RunningToro.png"
    },
    {
      name: "Gold Stealer",
      GAMEID: "9cec85e2f5c2a0545c10825e897ec433",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Gold-Stealer.png"
    },
    {
      name: "All Star Team",
      GAMEID: "8677aafb4968ee948c42ef31cbcc6c66",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/All-Star-Team.png"
    },
    {
      name: "Dragon's Treasure",
      GAMEID: "9b8589482492af6a92397a889ce24784",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragons-Treasure.png"
    },
    {
      name: "Great Lion",
      GAMEID: "e91f6b84921858afd5a62284d0dfa89b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Great-Lion.png"
    },
    {
      name: "Burning Xi-You",
      GAMEID: "979fc001722dd7c46edab5a787b86d21",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Burning-Xi-You.png"
    },
    {
      name: "All Wilds",
      GAMEID: "bb5c0ea65687c2ee63980f644045f9e4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/All-Wilds.png"
    },
    {
      name: "Jewel Luxury",
      GAMEID: "572ed9f08de5745603c052fd759989c5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Jewel-Luxury.png"
    },
    {
      name: "Meow",
      GAMEID: "271a0b04341b9b57c9fd46dbc8bb333a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Meow.png"
    },
    {
      name: "Loy Krathong",
      GAMEID: "d63414a615aa145466625ec440176f8e",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Loy-Krathong.png"
    },
    {
      name: "The Cupids",
      GAMEID: "3c71b0060fe7214f73ac21af86148b03",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Cupids.png"
    },
    {
      name: "Fruit King",
      GAMEID: "748c8f874063d6629dfc910dd38e85e5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fruit-King.png"
    },
    {
      name: "Chicky Parm Parm",
      GAMEID: "ff89d148948baec771661f4047e7215c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Chicky-Parm-Parm.png"
    },
    {
      name: "WonWonWon",
      GAMEID: "5c60a8521f10c864de5b1da61e1b014c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WonWonWon.png"
    },
    {
      name: "Magic World",
      GAMEID: "4c70c186616f00adb7cec5d6e58ed604",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Magic-World.png"
    },
    {
      name: "Sherlock Holmes",
      GAMEID: "f4ee292edc93a670a25e31e3d8ae3303",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sherlock-Holmes.png"
    },
    {
      name: "Summer Mood",
      GAMEID: "d67b92dd4bc3a7180aecf6a5f4eb61ed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Summer-Mood.png"
    },
    {
      name: "God Of Chess",
      GAMEID: "f72b5f2d241bc0ee370965f21692b96d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/God-Of-Chess.png"
    },
    {
      name: "FruitKingII",
      GAMEID: "737224273b2595a5fc6d5b419611ff00",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/FruitKingII.png"
    },
    {
      name: "Xmas",
      GAMEID: "86731029d440380de665d1705be2cbc8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Xmas.png"
    },
    {
      name: "Six Gacha",
      GAMEID: "a1676b8d40667bab6d107601347ab3c6",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Six-Gacha.png"
    },
    {
      name: "Gophers War",
      GAMEID: "82af8f5ea9cb9003accab2a685f6b7dc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Gophers-War.png"
    },
    {
      name: "Ninja Raccoon",
      GAMEID: "071b756a4d6b454a87641fa021d18e11",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ninja-Raccoon.png"
    },
    {
      name: "Fruity Carnival",
      GAMEID: "d859be0e915d1b72d6c3125fd3764eb0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fruity-Carnival.png"
    },
    {
      name: "Football Baby",
      GAMEID: "9f0cc6b78e12cc19bcfcd95488b5d781",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Football-Baby.png"
    },
    {
      name: "Pharaoh's Gold",
      GAMEID: "d40765682df6cd384a6624bdf2a6be8f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Pharaohs-Gold.png"
    },
    {
      name: "Poseidon",
      GAMEID: "2d44ee24e038513e1d8680d4dd534348",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Poseidon.png"
    },
    {
      name: "LongLongLong",
      GAMEID: "cf576c4aecc1bd3b077b4a78d1b426ec",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LongLongLong.png"
    },
    {
      name: "Detective Dee",
      GAMEID: "bda2e6a2e08382ae3e6cc407ab2a209c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Detective-Dee.png"
    },
    {
      name: "LuckyBoxes",
      GAMEID: "bcefd23a1c86c94c430ca39868eb36cc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LuckyBoxes.png"
    },
    {
      name: "Crazy NuoZha",
      GAMEID: "b9a08190e3f3aec328ddae2b0c43bb15",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Crazy-NuoZha.png"
    },
    {
      name: "Ecstatic Circus",
      GAMEID: "7f8fd8227e3b31934e1d86c0a5afb938",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ecstatic-Circus.png"
    },
    {
      name: "Dollar Bomb",
      GAMEID: "b54ad2b8e8217c07a22495f18589c276",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dollar-Bomb.png"
    },
    {
      name: "Fortune Gate",
      GAMEID: "a493bdd1bbe559f7a3fa5e5947982242",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Gate.png"
    },
    {
      name: "Sakura Legend",
      GAMEID: "8658e005b8bffc8e727a8846dae13900",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sakura-Legend.png"
    },
    {
      name: "Songkran Festival",
      GAMEID: "2cb558412aaccd52d6ad8b436953c73c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Songkran-Festival.png"
    },
    {
      name: "Coin Spinner",
      GAMEID: "48d0db2eab9a513a3c0974896e2ba704",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Coin-Spinner.png"
    },
    {
      name: "XIYOUJI",
      GAMEID: "4023d4dc30fb1e751576018ff64610df",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/XIYOUJI.png"
    },
    {
      name: "Sun Er Niang",
      GAMEID: "807a7b2beca7903201adb021098ad95c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sun-Er-Niang.png"
    },
    {
      name: "The Dragon Brings Wealth",
      GAMEID: "57e95e50da6625ed1e3c00e6266e39cb",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Dragon-Brings-Wealth.png"
    },
    {
      name: "ROLLING DRAGON",
      GAMEID: "77c171c91fb589c2c91879a4ebe8c911",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/ROLLING-DRAGON-.png"
    },
    {
      name: "Lonely Planet",
      GAMEID: "b8d4831b3631a06e1bfbe3da5e951789",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lonely-Planet.png"
    },
    {
      name: "World Cup Russia2018",
      GAMEID: "2409e5731f75846c32589aa11e97bf7b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/World-Cup-Russia2018.png"
    },
    {
      name: "Football Boots",
      GAMEID: "2058fb035a2950763935dcdb3552046d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Football-Boots.png"
    },
    {
      name: "Oo Ga Cha Ka",
      GAMEID: "109f1875d5ab0981b08e958828a6118d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Oo-Ga-Cha-Ka.png"
    },
    {
      name: "MONKEY KING",
      GAMEID: "fed3b52ed8e9d709e637a9482f576c64",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MONKEY-KING.png"
    },
    {
      name: "Monster Hunter",
      GAMEID: "01d19cf2fedc3bc18e2b8e880af687ed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Monster-Hunter.png"
    },
    {
      name: "JIN LIAN PAN",
      GAMEID: "2745d0933a8ab0621b76bb93f5a549cc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/JIN-LIAN-PAN-.png"
    },
    {
      name: "GoldenEggsJP",
      GAMEID: "6da38883f15c06b796d8daaed7f80939",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/GoldenEggsJP.png"
    },
    {
      name: "LongLaiFa",
      GAMEID: "ca69f05fd2a52a9fdee69dd819cbb4be",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LongLaiFa.png"
    },
    {
      name: "HUGA",
      GAMEID: "4e46334e0abde53e5e6cabe78f106764",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/HUGA.png"
    },
    {
      name: "PARTY ISLAND",
      GAMEID: "9b7af082e879ebb276affc760668b54d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/PARTY-ISLAND.png"
    },
    {
      name: "Double Happiness",
      GAMEID: "3632e72eedf24ef82f034d02282f90d4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Double-Happiness.png"
    },
    {
      name: "Big Wolf",
      GAMEID: "4fc02a42d9981442dc20fe9e03d169ad",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Big-Wolf.png"
    },
    {
      name: "Empress Wu",
      GAMEID: "0582ab3045c14b6268606c11f4d19f95",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Empress-Wu-.png"
    },
    {
      name: "TIGER HERO",
      GAMEID: "f523bb4fbe0dad42c44121cfdfe3ec9d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TIGER-HERO.png"
    },
    {
      name: "MonkeyOfficeLegend",
      GAMEID: "a26b4a919b9bc8865599ca5f105a8e58",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MonkeyOfficeLegend.png"
    },
    {
      name: "Pub Tycoon",
      GAMEID: "3a2bd5e7a1b3366cde75570d3ad93de8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Pub-Tycoon.png"
    },
    {
      name: "MULAN",
      GAMEID: "bb28e417cbd03f0ab9be560fdf7773e9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MULAN.png"
    },
    {
      name: "Mega Winner",
      GAMEID: "6667585b48442cde4516e2f6648dc530",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mega-Winner.png"
    },
    {
      name: "Lin Chong",
      GAMEID: "d46355c4d9fc77c4ae9d9df297390fb0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lin-Chong.png"
    },
    {
      name: "Slot 777",
      GAMEID: "3d76faac5931819507b7dfba02377f35",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Slot-777.png"
    },
    {
      name: "Lucky 3",
      GAMEID: "a369313204e62dbc8584d75cd3addc82",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lucky-3.png"
    },
    {
      name: "Pig Of Luck",
      GAMEID: "ef392c2fec8ad75d77131252b6ff3663",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Pig-Of-Luck.png"
    },
    {
      name: "Boots of Luck",
      GAMEID: "316b9e21b4bde165e506351ecf833930",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Boots-of-Luck.png"
    },
    {
      name: "Fortune Spirits",
      GAMEID: "a7f80a70e62368c389a23b300ccbf8a1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Spirits.png"
    },
    {
      name: "GENIE",
      GAMEID: "598c5d9c30378fdd48d4dfa2bb8c0c46",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/GENIE.png"
    },
    {
      name: "Rush Hour",
      GAMEID: "9d9bf67a8b6b1faf5a1dbfe6ff3dd206",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Rush-Hour.png"
    },
    {
      name: "Treasure of Seti",
      GAMEID: "528101a83d7f3518896e4fce061948f7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Treasure-of-Seti.png"
    },
    {
      name: "Wild Fudge",
      GAMEID: "cb9ddf2d9f433e19ca3d7fda21e520c9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wild-Fudge.png"
    },
    {
      name: "Diamond Fruit",
      GAMEID: "1360fd1d5b971769cdbc922b51303e3a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Diamond-Fruit.png"
    },
    {
      name: "Da Fu Xing",
      GAMEID: "804e9adae94f35f16a2d93bc584f7da0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Da-Fu-Xing.png"
    },
    {
      name: "Master Panda",
      GAMEID: "4a687f358c03e98ffbc4df618b2f1566",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Master-Panda.png"
    },
    {
      name: "Queen Of Dead",
      GAMEID: "f09e471f10d60dfc7fd9876c6711d8c8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Queen-Of-Dead.png"
    },
    {
      name: "Songkran",
      GAMEID: "fb1c07944e9b30c773975d5761f715b3",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Songkran.png"
    },
    {
      name: "Dragon Hunters",
      GAMEID: "9a1d746be3ce06c9617fde95da7299e7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Hunters.png"
    },
    {
      name: "The Legend Of Snake",
      GAMEID: "6ac22b2754657ac1f92c52c216ca3123",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Legend-Of-Snake-.png"
    },
    {
      name: "Niu Niu Niu",
      GAMEID: "ca92c58e1ba7a064226fd292e08f1e1f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Niu-Niu-Niu.png"
    },
    {
      name: "Royal Fruit",
      GAMEID: "2dc730c7c7cabe3ced14eadf4f800d23",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Royal-Fruit.png"
    },
    {
      name: "Golden Mayan",
      GAMEID: "4ca28ba2df8175e7742aafb08cb93acb",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Golden-Mayan.png"
    },
    {
      name: "Wild Chameleon",
      GAMEID: "1449bcd0cf997fcbd5db51b71f5a3afd",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wild-Chameleon.png"
    },
    {
      name: "Hollywood Pets",
      GAMEID: "b3626929bd5b55514e43cc9ea30ecdcf",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hollywood-Pets.png"
    },
    {
      name: "Fishing King",
      GAMEID: "396c1296f9805ec93cb73764c11e939b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fishing-King.png"
    },
    {
      name: "Myth",
      GAMEID: "6d7d54e9ac5d6fbccb4e90f59bb07f54",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Myth.png"
    },
    {
      name: "Nezha",
      GAMEID: "c7177ae93f8b8ad8015d1c15fc84358f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Nezha.png"
    },
    {
      name: "HAPPY BUDDHA",
      GAMEID: "7e64a66d0d74af9f173ab913576b61ce",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/HAPPY-BUDDHA.png"
    },
    {
      name: "Cirque de fous",
      GAMEID: "d9d86e86284357426995e080250e2662",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Cirque-de-fous.png"
    },
    {
      name: "JUNGLE ISLAND",
      GAMEID: "8797a9b3500b2cc510aab54f8f65c9b0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/JUNGLE-ISLAND.png"
    },
    {
      name: "Hong Kong Flavor",
      GAMEID: "32b8e2de14d2dc9fa7de9e60c39181e2",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hong-Kong-Flavor.png"
    },
    {
      name: "Beanstalk",
      GAMEID: "bc6315b1d328ba2a6719d3ce54ecfc6d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Beanstalk.png"
    },
    {
      name: "Xmas Tales",
      GAMEID: "5aa01f1fb8c92635c69d399deda516b2",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Xmas-Tales.png"
    },
    {
      name: "Peeking Banker Bull-Bull",
      GAMEID: "e21186914febf15786f84951e013a37a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Peeking-Banker-Bull-Bull.png"
    },
    {
      name: "Banker Dice Bull-Bull",
      GAMEID: "874ef5c8f7c51b3e6e8d8f3189917219",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Banker-Dice-Bull-Bull.png"
    },
    {
      name: "Thai Pok Deng",
      GAMEID: "5843c49f399e462d8e4852c45bf14d34",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Thai-Pok-Deng.png"
    }
  ]
  const others_games=[
   
    {
      name: "Jump High 2",
      GAMEID: "8d57ec6274960fe2f2c252f4a49adf7f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Jump-High-2.png"
    },
    {
      name: "Jumping mobile",
      GAMEID: "1282953e9452fe2852cb1724b4b9d617",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Jumping-mobile.png"
    },
    
    {
      name: "Fa Cai Shen M",
      GAMEID: "4c5fff40be0ac1e597fa24f3c0a656e9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fa-Cai-Shen-M.png"
    },
    {
      name: "TreasureBowl",
      GAMEID: "5172f73c2829b9cec48b0c7d856ae26a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TreasureBowl.png"
    },
   
    {
      name: "Mirror Mirror",
      GAMEID: "d9550ed556610505851f425c37fb57fd",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mirror-Mirror.png"
    },
    {
      name: "MuayThai",
      GAMEID: "a27e8f382f0ce434b0c42079ebe33221",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MuayThai.png"
    },
    {
      name: "Rave Jump2",
      GAMEID: "b9aeb15cd98fb93d5dca0bbddbc9c79f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Rave-Jump2.png"
    },
    {
      name: "Aladdin's lamp",
      GAMEID: "44b775adacc090fd07ad6b24a6b55963",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Aladdins-lamp.png"
    },
    {
      name: "Striker WILD",
      GAMEID: "4a3a333562badf48383a10c7fbf8de26",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Striker-WILD.png"
    },
    {
      name: "WaterWorld",
      GAMEID: "0eebf2f9aaa4705795ce5b01780751ef",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WaterWorld.png"
    },
    {
      name: "Fa Cai Fu Wa",
      GAMEID: "bad08f4186e60ce20918fcc23a955d7c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fa-Cai-Fu-Wa.png"
    },
    {
      name: "Mr. Miser",
      GAMEID: "264af007099b8306f9c4e4e45485500d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mr.-Miser.png"
    },
    {
      name: "Uproar In Heaven",
      GAMEID: "86c2ea7d87d4ca8f8f305a0a0b0de846",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Uproar-In-Heaven.png"
    },
    {
      name: "GuGuGu2",
      GAMEID: "506e63d96c5377a1d0d2368357e323f9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/GuGuGu2.png"
    },
    {
      name: "Wheel Money",
      GAMEID: "cf4cfcd1f517360be7e3f5e35cb277ef",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wheel-Money.png"
    },
    {
      name: "5 Boxing",
      GAMEID: "6075420770ec2fe9c31b48159729299c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/5-Boxing.png"
    },
    {
      name: "Dragon Ball",
      GAMEID: "83e1f2077918e63f9cbde70f6e3d9ce0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Ball.png"
    },
    {
      name: "The Beast War",
      GAMEID: "8c9750a6cc03f3d0af0a7853ac124fda",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Beast-War.png"
    },
    {
      name: "HappyRichYear",
      GAMEID: "cbce4da7f8b89f8b6b569af14af75d9c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/HappyRichYear.png"
    },
    {
      name: "Floating Market",
      GAMEID: "a34f4808447d12be37d16adf9eaed572",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Floating-Market.png"
    },
    {
      name: "King of Atlantis",
      GAMEID: "e4a15094c2ae54ffc6d77187fff0d2d7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/King-of-Atlantis.png"
    },
    {
      name: "Apsaras",
      GAMEID: "feb4444198c8146d213f9594325ff7d7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Apsaras.png"
    },
    {
      name: "The Chicken House",
      GAMEID: "2e5f381d3f9db2217fb113c829a79f2a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Chicken-House.png"
    },
    {
      name: "Zeus M",
      GAMEID: "fb33a6613e5ba5b8e42f035fbd4e103d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Zeus-M.png"
    },
    {
      name: 777,
      GAMEID: "521c3e444d06b25dc5ed6b6768200d44",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/777.png"
    },
    {
      name: "LuckyBatsJP",
      GAMEID: "9bef1fbf45383b40e170c57a06352a37",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LuckyBatsJP.png"
    },
    {
      name: "WuKong&Peaches",
      GAMEID: "d0436aec31880e65ad98eef9b3981fcb",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WuKong&Peaches.png"
    },
    {
      name: "Sky Lanterns",
      GAMEID: "48f9ce3f231f3993c6ec908509d61688",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sky-Lanterns.png"
    },
    {
      name: "Kronos",
      GAMEID: "f6747563ecef5cb4803e523cc40d7496",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Kronos.png"
    },
    {
      name: "Hephaestus",
      GAMEID: "ccd2f2ff80e15cf4972f1d6357c0f8d5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hephaestus.png"
    },
    {
      name: "King Kong Shake",
      GAMEID: "364284517a08f983992e3ee471960c0d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/King-Kong-Shake.png"
    },
    {
      name: "Gu Gu Gu 2 M",
      GAMEID: "24e0e334a06f1c2f609908ea51f56945",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/-Gu-Gu-Gu-2-M.png"
    },
    {
      name: "Fortune Dragon",
      GAMEID: "3b00fa061de9d0a6ed9843fa95ddb5dc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Dragon.png"
    },
    {
      name: "Shou-Xin",
      GAMEID: "2b0b1d8d7c8c49ae282f328795916fd1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Shou-Xin.png"
    },
    {
      name: "Mafia",
      GAMEID: "a239266b6011750a0105b676ca92b2f3",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mafia.png"
    },
    {
      name: "Hot DJ",
      GAMEID: "3f1df3f204333b25730681b291a60333",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hot-DJ.png"
    },
    {
      name: "Mr. Rich",
      GAMEID: "a34dc998bf7f4c4c0a62b2810cd0e30e",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mr.-Rich.png"
    },
    {
      name: "Rave Jump 2 M",
      GAMEID: "73e303cf417c6bd211ef536507a35b82",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Rave-Jump-2-M.png"
    },
    {
      name: "Fire Chibi M",
      GAMEID: "7fa49af4cf85457b5340d98cbe282563",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire-Chibi-M.png"
    },
    {
      name: "Wolf Moon",
      GAMEID: "fda7ba3b397e7940596a30639e2ab9e1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wolf-Moon.png"
    },
    {
      name: "Football Fever",
      GAMEID: "551c0c158cfcbe2d8c97960f70c7fec8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Football-Fever.png"
    },
    {
      name: "Golden Eggs",
      GAMEID: "69092d998124631d4a8925944bce67b5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Golden-Eggs.png"
    },
    {
      name: "CHICAGOⅡ",
      GAMEID: "1112003dee0f8525b1cbee98a6ab1368",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/CHICAGOII.png"
    },
    {
      name: "TreasureBowlJP",
      GAMEID: "a302435d829c9a6b823b508c2df7aec9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TreasureBowlJP.png"
    },
    {
      name: "Apollo",
      GAMEID: "9f6d5cad4677d3aa3feeb7b907d9a93a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Apollo.png"
    },
    {
      name: "OrientalBeauty",
      GAMEID: "0e15fd4fa6b9590001cdd71555bd8b87",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/OrientalBeauty.png"
    },
    {
      name: "Hero of the 3 Kingdoms - Cao Cao",
      GAMEID: "a174a38fb0fb007d348c03086ed0efed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hero-of-the-3-Kingdoms-Cao-Cao.png"
    },
    {
      name: "Sweet POP",
      GAMEID: "e51f1ecea20f87eee1149dac9e78852c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sweet-POP.png"
    },
    {
      name: "Myeong-ryang",
      GAMEID: "5c10bbe32ed9527d19711986973968a4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Myeong-ryang.png"
    },
    {
      name: "Treasure House",
      GAMEID: "8a244973588309c9d06b3d2f23020e1e",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Treasure-House.png"
    },
    {
      name: "Wing Chun",
      GAMEID: "c20937482acb4256f02c2d9f72258fbe",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wing-Chun.png"
    },
    {
      name: "Fortune Totem",
      GAMEID: "7941e7cf88f7a30533b7c7ab98b3c639",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Totem.png"
    },
    {
      name: "Running Animals",
      GAMEID: "522977276f1e38334bb71762710d1d8b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Running-Animals.png"
    },
    {
      name: "Fire777",
      GAMEID: "2453bbce4a11850700f3f8634a130e4f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fire777.png"
    },
    {
      name: "Vampire Kiss",
      GAMEID: "b0bf4de1e3881b266a4dfc442e1f665d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Vampire-Kiss.png"
    },
    {
      name: "WanBaoDino",
      GAMEID: "557550df7526b2a8641c08b14c50304d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WanBaoDino.png"
    },
    {
      name: "Ne Zha Advent",
      GAMEID: "c0adf8478aef16eae670cce8258623b1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ne-Zha-Advent.png"
    },
    {
      name: "Greek Gods",
      GAMEID: "15e8bdff25079b4be98f84cdea37d1ed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Greek-Gods.png"
    },
    {
      name: "Zuma Wild",
      GAMEID: "b1c4e04fc5de9e6fe06baf44a650d0e6",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Zuma-Wild.png"
    },
    {
      name: "Dragon Koi",
      GAMEID: "f800040e6818ede103dc94b3d3bebbc5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Koi.png"
    },
    {
      name: "SkrSkr",
      GAMEID: "316d8570b1c69f52046d5bb0bbb0a0e3",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/SkrSkr.png"
    },
    {
      name: "Acrobatics",
      GAMEID: "b8f1a2b30586584ac0f20b9ba426ee60",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Acrobatics.png"
    },
    {
      name: "Ganesha Jr.",
      GAMEID: "461e0b9219d51eda0f6413b19153a1c6",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ganesha-Jr..png"
    },
    {
      name: "Yuan Bao",
      GAMEID: "5e4818e6c8946a3d71653e3d22a9a1c9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Yuan-Bao.png"
    },
    {
      name: "Wild Tarzan",
      GAMEID: "dd2046e37aa94f0a6b77497452ac0286",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wild-Tarzan.png"
    },
    {
      name: "Diamond treasure",
      GAMEID: "2f3e4881d605653d536e8b5ab21e113b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/-Diamond-treasure.png"
    },
    {
      name: "TreasureIsland",
      GAMEID: "b3c866fb2c529acf4175603e2c02d074",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TreasureIsland.png"
    },
    {
      name: "Red Phoenix",
      GAMEID: "a7034f531232014969b8b613fccd0a47",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Red-Phoenix.png"
    },
    {
      name: "Gu Gu Gu M",
      GAMEID: "b5d1c587f497cd331d18f3a618f99229",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Gu-Gu-Gu-M.png"
    },
    {
      name: "Detective Dee2",
      GAMEID: "d91e2b4c05cd7ac6ac59adb3d5f853ab",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Detective-Dee2.png"
    },
    {
      name: "Lucky Tigers",
      GAMEID: "b18de9efd3c251a32eed6ac7e97c67d7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lucky-Tigers.png"
    },
    {
      name: "Dragon Heart",
      GAMEID: "d8cb3a9429cd45c2ec612cb3220acecd",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Heart.png"
    },
    {
      name: "Lord Ganesha",
      GAMEID: "89c763b3761557eaa960d022cdd73921",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lord-Ganesha.png"
    },
    {
      name: "Hot Pinatas",
      GAMEID: "171dd44d68bd47df9d2bc386082ca340",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hot-Pinatas.png"
    },
    {
      name: 888,
      GAMEID: "708c6a3de19dd4d7674efea3ef2fe40f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/888.png"
    },
    {
      name: "RunningToro",
      GAMEID: "2df7d3f0fb6dc289a29d58067ab1c596",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/RunningToro.png"
    },
    {
      name: "Gold Stealer",
      GAMEID: "9cec85e2f5c2a0545c10825e897ec433",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Gold-Stealer.png"
    },
    {
      name: "All Star Team",
      GAMEID: "8677aafb4968ee948c42ef31cbcc6c66",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/All-Star-Team.png"
    },
    {
      name: "Dragon's Treasure",
      GAMEID: "9b8589482492af6a92397a889ce24784",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragons-Treasure.png"
    },
    {
      name: "Great Lion",
      GAMEID: "e91f6b84921858afd5a62284d0dfa89b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Great-Lion.png"
    },
    {
      name: "Burning Xi-You",
      GAMEID: "979fc001722dd7c46edab5a787b86d21",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Burning-Xi-You.png"
    },
    {
      name: "All Wilds",
      GAMEID: "bb5c0ea65687c2ee63980f644045f9e4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/All-Wilds.png"
    },
    {
      name: "Jewel Luxury",
      GAMEID: "572ed9f08de5745603c052fd759989c5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Jewel-Luxury.png"
    },
    {
      name: "Meow",
      GAMEID: "271a0b04341b9b57c9fd46dbc8bb333a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Meow.png"
    },
    {
      name: "Loy Krathong",
      GAMEID: "d63414a615aa145466625ec440176f8e",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Loy-Krathong.png"
    },
    {
      name: "The Cupids",
      GAMEID: "3c71b0060fe7214f73ac21af86148b03",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Cupids.png"
    },
    {
      name: "Fruit King",
      GAMEID: "748c8f874063d6629dfc910dd38e85e5",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fruit-King.png"
    },
    {
      name: "Chicky Parm Parm",
      GAMEID: "ff89d148948baec771661f4047e7215c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Chicky-Parm-Parm.png"
    },
    {
      name: "WonWonWon",
      GAMEID: "5c60a8521f10c864de5b1da61e1b014c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/WonWonWon.png"
    },
    {
      name: "Magic World",
      GAMEID: "4c70c186616f00adb7cec5d6e58ed604",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Magic-World.png"
    },
    {
      name: "Sherlock Holmes",
      GAMEID: "f4ee292edc93a670a25e31e3d8ae3303",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sherlock-Holmes.png"
    },
    {
      name: "Summer Mood",
      GAMEID: "d67b92dd4bc3a7180aecf6a5f4eb61ed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Summer-Mood.png"
    },
    {
      name: "God Of Chess",
      GAMEID: "f72b5f2d241bc0ee370965f21692b96d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/God-Of-Chess.png"
    },
    {
      name: "FruitKingII",
      GAMEID: "737224273b2595a5fc6d5b419611ff00",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/FruitKingII.png"
    },
    {
      name: "Xmas",
      GAMEID: "86731029d440380de665d1705be2cbc8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Xmas.png"
    },
    {
      name: "Six Gacha",
      GAMEID: "a1676b8d40667bab6d107601347ab3c6",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Six-Gacha.png"
    },
    {
      name: "Gophers War",
      GAMEID: "82af8f5ea9cb9003accab2a685f6b7dc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Gophers-War.png"
    },
    {
      name: "Ninja Raccoon",
      GAMEID: "071b756a4d6b454a87641fa021d18e11",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ninja-Raccoon.png"
    },
    {
      name: "Fruity Carnival",
      GAMEID: "d859be0e915d1b72d6c3125fd3764eb0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fruity-Carnival.png"
    },
    {
      name: "Football Baby",
      GAMEID: "9f0cc6b78e12cc19bcfcd95488b5d781",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Football-Baby.png"
    },
    {
      name: "Pharaoh's Gold",
      GAMEID: "d40765682df6cd384a6624bdf2a6be8f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Pharaohs-Gold.png"
    },
    {
      name: "Poseidon",
      GAMEID: "2d44ee24e038513e1d8680d4dd534348",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Poseidon.png"
    },
    {
      name: "LongLongLong",
      GAMEID: "cf576c4aecc1bd3b077b4a78d1b426ec",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LongLongLong.png"
    },
    {
      name: "Detective Dee",
      GAMEID: "bda2e6a2e08382ae3e6cc407ab2a209c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Detective-Dee.png"
    },
    {
      name: "LuckyBoxes",
      GAMEID: "bcefd23a1c86c94c430ca39868eb36cc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LuckyBoxes.png"
    },
    {
      name: "Crazy NuoZha",
      GAMEID: "b9a08190e3f3aec328ddae2b0c43bb15",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Crazy-NuoZha.png"
    },
    {
      name: "Ecstatic Circus",
      GAMEID: "7f8fd8227e3b31934e1d86c0a5afb938",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Ecstatic-Circus.png"
    },
    {
      name: "Dollar Bomb",
      GAMEID: "b54ad2b8e8217c07a22495f18589c276",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dollar-Bomb.png"
    },
    {
      name: "Fortune Gate",
      GAMEID: "a493bdd1bbe559f7a3fa5e5947982242",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Gate.png"
    },
    {
      name: "Sakura Legend",
      GAMEID: "8658e005b8bffc8e727a8846dae13900",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sakura-Legend.png"
    },
    {
      name: "Songkran Festival",
      GAMEID: "2cb558412aaccd52d6ad8b436953c73c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Songkran-Festival.png"
    },
    {
      name: "Coin Spinner",
      GAMEID: "48d0db2eab9a513a3c0974896e2ba704",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Coin-Spinner.png"
    },
    {
      name: "XIYOUJI",
      GAMEID: "4023d4dc30fb1e751576018ff64610df",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/XIYOUJI.png"
    },
    {
      name: "Sun Er Niang",
      GAMEID: "807a7b2beca7903201adb021098ad95c",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Sun-Er-Niang.png"
    },
    {
      name: "The Dragon Brings Wealth",
      GAMEID: "57e95e50da6625ed1e3c00e6266e39cb",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Dragon-Brings-Wealth.png"
    },
    {
      name: "ROLLING DRAGON",
      GAMEID: "77c171c91fb589c2c91879a4ebe8c911",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/ROLLING-DRAGON-.png"
    },
    {
      name: "Lonely Planet",
      GAMEID: "b8d4831b3631a06e1bfbe3da5e951789",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lonely-Planet.png"
    },
    {
      name: "World Cup Russia2018",
      GAMEID: "2409e5731f75846c32589aa11e97bf7b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/World-Cup-Russia2018.png"
    },
    {
      name: "Football Boots",
      GAMEID: "2058fb035a2950763935dcdb3552046d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Football-Boots.png"
    },
    {
      name: "Oo Ga Cha Ka",
      GAMEID: "109f1875d5ab0981b08e958828a6118d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Oo-Ga-Cha-Ka.png"
    },
    {
      name: "MONKEY KING",
      GAMEID: "fed3b52ed8e9d709e637a9482f576c64",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MONKEY-KING.png"
    },
    {
      name: "Monster Hunter",
      GAMEID: "01d19cf2fedc3bc18e2b8e880af687ed",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Monster-Hunter.png"
    },
    {
      name: "JIN LIAN PAN",
      GAMEID: "2745d0933a8ab0621b76bb93f5a549cc",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/JIN-LIAN-PAN-.png"
    },
    {
      name: "GoldenEggsJP",
      GAMEID: "6da38883f15c06b796d8daaed7f80939",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/GoldenEggsJP.png"
    },
    {
      name: "LongLaiFa",
      GAMEID: "ca69f05fd2a52a9fdee69dd819cbb4be",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/LongLaiFa.png"
    },
    {
      name: "HUGA",
      GAMEID: "4e46334e0abde53e5e6cabe78f106764",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/HUGA.png"
    },
    {
      name: "PARTY ISLAND",
      GAMEID: "9b7af082e879ebb276affc760668b54d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/PARTY-ISLAND.png"
    },
    {
      name: "Double Happiness",
      GAMEID: "3632e72eedf24ef82f034d02282f90d4",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Double-Happiness.png"
    },
    {
      name: "Big Wolf",
      GAMEID: "4fc02a42d9981442dc20fe9e03d169ad",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Big-Wolf.png"
    },
    {
      name: "Empress Wu",
      GAMEID: "0582ab3045c14b6268606c11f4d19f95",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Empress-Wu-.png"
    },
    {
      name: "TIGER HERO",
      GAMEID: "f523bb4fbe0dad42c44121cfdfe3ec9d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/TIGER-HERO.png"
    },
    {
      name: "MonkeyOfficeLegend",
      GAMEID: "a26b4a919b9bc8865599ca5f105a8e58",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MonkeyOfficeLegend.png"
    },
    {
      name: "Pub Tycoon",
      GAMEID: "3a2bd5e7a1b3366cde75570d3ad93de8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Pub-Tycoon.png"
    },
    {
      name: "MULAN",
      GAMEID: "bb28e417cbd03f0ab9be560fdf7773e9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/MULAN.png"
    },
    {
      name: "Mega Winner",
      GAMEID: "6667585b48442cde4516e2f6648dc530",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Mega-Winner.png"
    },
    {
      name: "Lin Chong",
      GAMEID: "d46355c4d9fc77c4ae9d9df297390fb0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lin-Chong.png"
    },
    {
      name: "Slot 777",
      GAMEID: "3d76faac5931819507b7dfba02377f35",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Slot-777.png"
    },
    {
      name: "Lucky 3",
      GAMEID: "a369313204e62dbc8584d75cd3addc82",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Lucky-3.png"
    },
    {
      name: "Pig Of Luck",
      GAMEID: "ef392c2fec8ad75d77131252b6ff3663",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Pig-Of-Luck.png"
    },
    {
      name: "Boots of Luck",
      GAMEID: "316b9e21b4bde165e506351ecf833930",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Boots-of-Luck.png"
    },
    {
      name: "Fortune Spirits",
      GAMEID: "a7f80a70e62368c389a23b300ccbf8a1",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fortune-Spirits.png"
    },
    {
      name: "GENIE",
      GAMEID: "598c5d9c30378fdd48d4dfa2bb8c0c46",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/GENIE.png"
    },
    {
      name: "Rush Hour",
      GAMEID: "9d9bf67a8b6b1faf5a1dbfe6ff3dd206",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Rush-Hour.png"
    },
    {
      name: "Treasure of Seti",
      GAMEID: "528101a83d7f3518896e4fce061948f7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Treasure-of-Seti.png"
    },
    {
      name: "Wild Fudge",
      GAMEID: "cb9ddf2d9f433e19ca3d7fda21e520c9",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wild-Fudge.png"
    },
    {
      name: "Diamond Fruit",
      GAMEID: "1360fd1d5b971769cdbc922b51303e3a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Diamond-Fruit.png"
    },
    {
      name: "Da Fu Xing",
      GAMEID: "804e9adae94f35f16a2d93bc584f7da0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Da-Fu-Xing.png"
    },
    {
      name: "Master Panda",
      GAMEID: "4a687f358c03e98ffbc4df618b2f1566",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Master-Panda.png"
    },
    {
      name: "Queen Of Dead",
      GAMEID: "f09e471f10d60dfc7fd9876c6711d8c8",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Queen-Of-Dead.png"
    },
    {
      name: "Songkran",
      GAMEID: "fb1c07944e9b30c773975d5761f715b3",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Songkran.png"
    },
    {
      name: "Dragon Hunters",
      GAMEID: "9a1d746be3ce06c9617fde95da7299e7",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Dragon-Hunters.png"
    },
    {
      name: "The Legend Of Snake",
      GAMEID: "6ac22b2754657ac1f92c52c216ca3123",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/The-Legend-Of-Snake-.png"
    },
    {
      name: "Niu Niu Niu",
      GAMEID: "ca92c58e1ba7a064226fd292e08f1e1f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Niu-Niu-Niu.png"
    },
    {
      name: "Royal Fruit",
      GAMEID: "2dc730c7c7cabe3ced14eadf4f800d23",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Royal-Fruit.png"
    },
    {
      name: "Golden Mayan",
      GAMEID: "4ca28ba2df8175e7742aafb08cb93acb",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Golden-Mayan.png"
    },
    {
      name: "Wild Chameleon",
      GAMEID: "1449bcd0cf997fcbd5db51b71f5a3afd",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Wild-Chameleon.png"
    },
    {
      name: "Hollywood Pets",
      GAMEID: "b3626929bd5b55514e43cc9ea30ecdcf",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hollywood-Pets.png"
    },
    {
      name: "Fishing King",
      GAMEID: "396c1296f9805ec93cb73764c11e939b",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Fishing-King.png"
    },
    {
      name: "Myth",
      GAMEID: "6d7d54e9ac5d6fbccb4e90f59bb07f54",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Myth.png"
    },
    {
      name: "Nezha",
      GAMEID: "c7177ae93f8b8ad8015d1c15fc84358f",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Nezha.png"
    },
    {
      name: "HAPPY BUDDHA",
      GAMEID: "7e64a66d0d74af9f173ab913576b61ce",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/HAPPY-BUDDHA.png"
    },
    {
      name: "Cirque de fous",
      GAMEID: "d9d86e86284357426995e080250e2662",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Cirque-de-fous.png"
    },
    {
      name: "JUNGLE ISLAND",
      GAMEID: "8797a9b3500b2cc510aab54f8f65c9b0",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/JUNGLE-ISLAND.png"
    },
    {
      name: "Hong Kong Flavor",
      GAMEID: "32b8e2de14d2dc9fa7de9e60c39181e2",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Hong-Kong-Flavor.png"
    },
    {
      name: "Beanstalk",
      GAMEID: "bc6315b1d328ba2a6719d3ce54ecfc6d",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Beanstalk.png"
    },
    {
      name: "Xmas Tales",
      GAMEID: "5aa01f1fb8c92635c69d399deda516b2",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Xmas-Tales.png"
    },
    {
      name: "Peeking Banker Bull-Bull",
      GAMEID: "e21186914febf15786f84951e013a37a",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Peeking-Banker-Bull-Bull.png"
    },
    {
      name: "Banker Dice Bull-Bull",
      GAMEID: "874ef5c8f7c51b3e6e8d8f3189917219",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Banker-Dice-Bull-Bull.png"
    },
    {
      name: "Thai Pok Deng",
      GAMEID: "5843c49f399e462d8e4852c45bf14d34",
      provider: "cq9",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/cq9/Thai-Pok-Deng.png"
    }
  ]
  useEffect(() => {
    window.scrollTo(0,0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    
  },[]);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

               
                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Latest Games</span>{" "}
                    <span className="all cursor-pointer" onClick={()=> navigate('/cq9All')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={cQ9_games} />
                  </div>
                </div>
                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Hot Games</span>{" "}
                    <span className="all cursor-pointer" onClick={()=> navigate('/cq9All')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={hot_games} />
                  </div>
                </div>
                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Other Games</span>{" "}
                    <span className="all cursor-pointer" onClick={()=> navigate('/cq9All')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={others_games} />
                  </div>
                </div>
                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default CQ9Home;
